import type { MapState } from './reducer';
import { compose } from 'redux';

import type { AppState } from '../AppState';

export const selectMapDomain = (state: AppState) => state.map;

export const selectOpenMapPopup = compose((domain: MapState) => domain.openPopup, selectMapDomain);

export const selectZoomLevel = compose((domain: MapState) => domain.zoomLevel, selectMapDomain);
